import React, { useEffect, useState } from 'react';
import { Button, Checkbox, ColorPicker, DatePicker, Form, Select, Switch, Tooltip } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import useProductTagAPI from '../../apis/productTagAPI';
import EventEmitter from '../../../utils/eventEmitter';


const applicability = [
  {value: '', label: ''},
  {value: 'in_store', label: 'In-store'},
  {value: 'online', label: 'Online'},
]


const ProductTagChanges = () => {
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const tag = useLoaderData();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(tag.name ? tag.name : '');
  const { create, update } = useProductTagAPI();


  const onChangeName = e => setName(e.target.value);

  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['color'] = typeof(data.color) === 'string' ? data.color : data.color.toHexString();
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    create(data, success);
    // console.log(data.color.toHexString())
    console.log(data)
  }

  const handleUpdate = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['color'] = typeof(data.color) === 'string' ? data.color : data.color.toHexString();
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    update(tag.seo, data, success);
    // console.log(data)
  }

  useEffect(() => {
    EventEmitter.subscribe('productTag_response', data => {
      navigate('/inventory/product-tags/'+data);
    });
    return () => EventEmitter.unsubscribe('productTag_response');
  },[]);

  return (
    <div className='container mx-auto' style={{maxWidth: '900px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/product-tags'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Product Tags</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ tag.name ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {tag.name && <Button onClick={handleUpdate}>UPDATE</Button>}
      </div>
      <div className='mt-5 bg-white p-3'>
        <FloatingLabel 
          className='text-2xl' 
          variant="standard" 
          label="Tag Name" 
          value={name} 
          onChange={onChangeName}
          style={{maxWidth: '500px'}}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{span: 5}}
          initialValues={tag.seo ? tag :
            {active: true, color: "#1677ff"}}
          variant='borderless'
        >
          <Form.Item label='Applicability' name={'applicability'} className='font-semibold text-gray-800 mb-1' required>
            <Select options={applicability} className='font-normal' style={{width: '300px'}}/>
          </Form.Item>
          <Form.Item label='Color' name={'color'} className='font-semibold text-gray-800 mb-1' required>
            <ColorPicker size="small" showText />
          </Form.Item>
          <Form.Item label='Active' name={'active'} className='font-semibold text-gray-800 mb-1' required>
            <Switch />
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}
export default ProductTagChanges;